import dayjs from 'dayjs';
import { NoteStatus, ReweightingNote } from '../../Models/ReWeightingModels/Workspace';

const kilograms = new Intl.NumberFormat('is-IS', { maximumFractionDigits: 2 });
export const formatKg = (value: number) => kilograms.format(value);
export const formatDate = (value: string | null) => value ? dayjs(value).format('DD.MM.YYYY') : 'Óskráð';
export const statusLabels: Record<NoteStatus, string> = {
  open: 'Opið', closed: 'Lokað', review: 'Í yfirferð', expired: 'Frestur liðinn',
};
export const statusColors: Record<NoteStatus, 'default' | 'success' | 'warning' | 'error'> = {
  open: 'default', closed: 'success', review: 'warning', expired: 'error',
};
export function deadlineLabel(note: ReweightingNote) {
  if (note.hasMissingDeadline) return 'Skilafrestur óskráður';
  if (note.isClosed) return `Lokað ${formatDate(note.closedAt)}`;
  if (note.isExpired) return `Frestur liðinn · ${formatDate(note.dueDate)}`;
  const days = dayjs(note.dueDate).startOf('day').diff(dayjs(note.serverDate).startOf('day'), 'day');
  return days === 0 ? 'Skila þarf í dag' : days === 1 ? 'Skila þarf á morgun' : `Skilafrestur ${formatDate(note.dueDate)}`;
}
